class PdfTemplate {
    id: number;
    name: string;
    organisationId: number;
    companyId: number;
    mappingId: number;
    config: PdfTemplateConfig;

    constructor(data: any = null) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "New Template";
        this.organisationId = data?.organisationId ?? 0;
        this.companyId = data?.companyId ?? 0;
        this.mappingId = data?.mappingId ?? 0;
        this.config = new PdfTemplateConfig(data?.config);
    }

    save(newPdfTemplate: boolean = false, sucessCallback: Function = null) {
        let model = {
            newPdfTemplate: newPdfTemplate,
            pdfTemplate: this,
        };

        let o = {
            url: urlConfigs.pdfTemplate + "Save",
            data: model,
            dataType: "json",
            async: false,
        } as RequestServerParams
        o.successFunction = function (data) {
            if (model.newPdfTemplate) {
                model.pdfTemplate.id = data.id;
            }

            model.pdfTemplate.config.header = data.header;
            model.pdfTemplate.config.footer = data.footer;

            sucessCallback?.(data);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to save PDF template";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    delete(sucessCallback: Function = null, failureFunction: Function = null) {
        let o = {
            url: urlConfigs.pdfTemplate + "Delete",
            data: { id: this.id },
            dataType: "json",
            async: false,
        } as RequestServerParams
        o.successFunction = function (data) {
            sucessCallback?.(data);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to delete PDF template";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);

            failureFunction?.(`${errorItem.userMessage} - ${textStatus}`);
        };

        irGlobal.requestServer(o);
    }

    validCompany(companyId: number) {
        if (irSettings.multiTenant) {
            if (this.organisationId == 0 || this.organisationId === null)
                return true;

            var company = CompanyService.getCompany(companyId);
            if (this.organisationId == company.organisationId && (this.companyId === 0 || this.companyId === null)) {
                return true;
            }

            return this.companyId == companyId;
        }

        return true;
    }
}